module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/sightseeing_1-55c61c127d612ef41b76a610aa528f27.jpg";